import axios from 'axios'
import QS from 'qs'
// const token = localStorage.getItem('token')
// if(token) {
//     const _token = token.slice(1,-1)
//     axios.defaults.headers.common['Authorization'] = "Bearer" + " " + _token
// }
axios.defaults.baseURL = 'http://wtbu-lab.hooook.com/'

axios.defaults.timeout = 10000
// axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = 'Bearer' + ' ' + token.slice(1, -1)
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
  })
}

export function del (url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, params)
      .then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js